import { Chart, Setting, Setting2 } from "iconsax-react";
import React from "react";
const GrowthSection = () => {
  return (
    <section className="w-full py-16 px-6 md:px-16 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto">
                <h2 className="text-lg md:text-2xl lg:text-[28px] xl:text-3xl font-bold max-w-sm md:max-w-lg lg:max-w-[560px] mx-auto text-center mb-4">

          Vant is perfect for individuals financial Growth
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#F6F9F8] rounded-xl">
            <div className="flex flex-col  gap-3 pt-4 md:pt-6 px-4 lg:px-8">
              <div className="w-10 h-10 rounded-full bg-[#03A300] flex items-center justify-center">
                <Chart size="18" color="#fff" />
              </div>
              <h3 className="text-lg text-[#282828] md:text-xl font-semibold">
                Grow Your Wealth with Smart Investments
              </h3>
              <p className="text-sm text-gray-400">
                Register, verify your identity, and start managing your money
                right away. No complex paperwork.
              </p>
            </div>

            <img
              src="./assets/piggy.png"
              alt="piggy bank"
              className="h-20 md:h-24 lg:h-[170px] xl:h-48 mx-auto mt-4 md:mt-5"
            />
          </div>

          <div className="bg-[#001027]  rounded-xl">
            <div className="flex flex-col  gap-3 pt-4 md:pt-6 px-4 lg:px-8">
              <div className="w-10 h-10 rounded-full bg-[#03A300] flex items-center justify-center">
                <Setting2 size="18" color="#fff" />
              </div>
              <h3 className="text-lg text-white md:text-xl font-semibold">
                Grow Your Wealth with Smart Investments
              </h3>
              <p className="text-sm text-white ">
                Access diverse investment options tailored to your financial
                goals and risk tolerance.
              </p>
            </div>

            <img
              src="./assets/trend.svg"
              alt="trend"
              className="h-20 md:h-24 lg:h-[170px] xl:h-48 mx-auto mt-4 md:mt-5"
            />
          </div>
 <div className="bg-[#F6F9F8] rounded-xl">
            <div className="flex flex-col  gap-3 pt-4 md:pt-6 px-4 lg:px-8">
              <div className="w-10 h-10 rounded-full bg-[#03A300] flex items-center justify-center">
                <Chart size="18" color="#fff" />
              </div>
              <h3 className="text-lg text-[#282828] md:text-xl font-semibold">
                Grow Your Wealth with Smart Investments
              </h3>
              <p className="text-sm text-gray-400">
                Register, verify your identity, and start managing your money
                right away. No complex paperwork.
              </p>
            </div>

            <img
              src="./assets/plane.svg"
              alt="plane"
              className="h-20 md:h-24 lg:h-[170px] xl:h-48  mt-4 md:mt-5"
            />
          </div>

        </div>

        <div className="flex justify-center mt-12">
            <a
            href="https://www.google.com/url?q=https://play.google.com/store/apps/details%3Fid%3Dcom.vant.app%26hl%3Den_US%26referrer%3Dutm_source%253Dgoogle%2526utm_medium%253Dorganic%2526utm_term%253Dvant%2Bapp&sa=U&ved=2ahUKEwixkrSIwpqBAxVgU0EAHVPRDAMQFnoECAUQAg&usg=AOvVaw3iL8zaaBsLYYudFsvEMTLY "
            target="_blank"
            rel="noopener noreferrer"
          >

               <button className="bg-[#03A300] hover:bg-[#028A00] text-white rounded-full px-8 py-2 md:py-3 text-[12px] md:text-sm lg:text-base" >
            Get Started
          </button>
          </a>
       
        </div>
      </div>
    </section>
  );
};

export default GrowthSection;
